module.exports = "pegasus/assets/column-13-basic.png";